import { Autocomplete, TextField } from '@mui/material'
import { INode, NodeType } from '../../../definitions/Nodes'
import { IAcceptedData } from '../../../definitions/NodesDescription'

interface P {
    acceptedData: IAcceptedData<NodeType>
    selectedNode: INode<NodeType>
    setSelected: (node: INode) => void
    disable: boolean
}

function NodeMultiSelectEditor({ selectedNode, acceptedData, setSelected, disable }: P) {
    const options = acceptedData?.options ?? []
    const values: any[] = selectedNode.data[acceptedData.parameter] ?? []
    const selectedOptions = acceptedData?.options?.filter(x => values.includes(x.value)) ?? []

    return (
        <div>
            <Autocomplete
                disabled={disable}
                size='small'
                multiple
                options={options}
                value={selectedOptions}
                getOptionLabel={option => option.label}
                onChange={(e, v) => {
                    e.preventDefault()
                    setSelected({ ...selectedNode, data: { ...selectedNode.data, [acceptedData.parameter]: v?.map(x => x.value) } })
                }}
                renderInput={params => {
                    return (
                        <TextField
                            {...params}
                            label={acceptedData.parameter}
                            error={acceptedData.isRequired && values.length === 0}
                            size='medium'
                            fullWidth
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    )
                }}
            />
        </div>
    )
}

export default NodeMultiSelectEditor
